import React from 'react'
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Grid,
  NativeSelect,
  TextField
} from '@mui/material'
import PropTypes from 'prop-types'

import { ColorBoxContent } from '../../../common/ui/colorBox'

export default function SubmitRequest({
  userName,
  userEmail,
  subjectOptions,
  ticketSubject,
  setTicketSubject,
  ticketMessage,
  setTicketMessage,
  handleCreateTicket,
  goPreviousPage
}) {
  return (
    <ColorBoxContent variant='secondary'>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl variant='standard' sx={{ pb: '1em' }}>
            <FormLabel>What do you need help with?</FormLabel>
            <NativeSelect
              defaultValue={ticketSubject}
              onChange={(e) => {
                setTicketSubject(e.target.value)
              }}
              data-cy='supportDropDown'
            >
              {Object.entries(subjectOptions).map((pair) => (
                <option key={pair[0]} value={pair[0]} data-cy={pair[0]}>
                  {pair[1]}
                </option>
              ))}
            </NativeSelect>
          </FormControl>
        </Grid>

        <Grid item xs={6}>
          <TextField
            label='Name'
            value={userName}
            sx={{ width: '100%' }}
            disabled
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label='Email'
            value={userEmail}
            sx={{ width: '100%' }}
            disabled
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            multiline
            rows={4}
            maxRows={8}
            sx={{ width: '100%', bgcolor: 'white' }}
            label='Message'
            placeholder={ticketMessage}
            required
            onChange={(e) => {
              setTicketMessage(e.target.value)
            }}
            data-cy='messageBox'
          />
        </Grid>

        <Grid item xs={12}>
          <Box display='flex' justifyContent='flex-end'>
            <Button
              variant='filled'
              onClick={handleCreateTicket}
              disabled=''
              data-cy='sendBtn'
            >
              Send
            </Button>
            <Button
              variant='secondary'
              onClick={() => goPreviousPage()}
              data-cy='backBtn'
            >
              Back
            </Button>
          </Box>
        </Grid>
      </Grid>
    </ColorBoxContent>
  )
}

SubmitRequest.propTypes = {
  userName: PropTypes.string,
  userEmail: PropTypes.string,
  subjectOptions: PropTypes.object,
  ticketSubject: PropTypes.string,
  setTicketSubject: PropTypes.func,
  ticketMessage: PropTypes.string,
  setTicketMessage: PropTypes.func,
  handleCreateTicket: PropTypes.func,
  goPreviousPage: PropTypes.func
}
